import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import RequiredForm from "./form/RequiredForm";
import { useFormik } from "formik";
import * as yup from "yup";
import cr from "../lib/request";
import PasswordInput from "./form/PasswordInput";
import { Cookies } from "typescript-cookie";
import useTrigger from "../globalState/useTrigger";
import { Link, useNavigate } from "react-router-dom";

export default function SigninModal() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const { trigger, setTrigger } = useTrigger();
  const navigate = useNavigate();

  const formik = useFormik({
    validateOnChange: false,

    initialValues: {
      username: "",
      password: "",
    },

    validationSchema: yup.object().shape({
      username: yup.string().required("Username harus diisi"),
      password: yup.string().required("Password harus diisi"),
    }),

    onSubmit: (values) => {
      setLoading(true);
      const url = `api/usercourse/login`;
      const payload = values;
      cr.post(url, payload)
        .then((response) => {
          if (response.status === 200) {
            Cookies.set("user", JSON.stringify(response.data.data), {
              expires: 3,
              path: "/",
            });
            toast({
              title: response.data.message,
              status: "success",
              duration: 5000,
              isClosable: true,
            });
            navigate("/mycourses");
            onClose();
            setTrigger(!trigger);
          }
        })
        .catch((error) => {
          console.log(error);
          toast({
            title: "Gagal sign in",
            description: error?.response?.data?.message || "-",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <>
      <Button id="signinbutton" flexShrink={0} className="btn" onClick={onOpen}>
        Sign in
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalCloseButton />

          <ModalHeader>Sign in</ModalHeader>

          <ModalBody>
            <form id={"signin"} onSubmit={formik.handleSubmit}>
              <FormControl
                mb={4}
                isInvalid={formik.errors.username ? true : false}
              >
                <FormLabel>
                  Username/Email
                  <RequiredForm />
                </FormLabel>
                <Input
                  name="username"
                  placeholder="Masukkan username/email"
                  onChange={formik.handleChange}
                />
                <FormErrorMessage>{formik.errors.username}</FormErrorMessage>
              </FormControl>

              <FormControl
                mb={4}
                isInvalid={formik.errors.password ? true : false}
              >
                <FormLabel>
                  Password
                  <RequiredForm />
                </FormLabel>
                <PasswordInput
                  name="password"
                  formik={formik}
                  placeholder="Masukkan password"
                />
                <FormErrorMessage>{formik.errors.password}</FormErrorMessage>
              </FormControl>
            </form>

            <Text as={Link} to={"/resetpassword"} color={"p.500"} fontSize={14}>
              Lupa password
            </Text>
          </ModalBody>

          <ModalFooter gap={2}>
            {/* <Button className="btn clicky" onClick={onClose}>
              Batal
            </Button> */}

            <Button
              colorScheme="ap"
              className="clicky"
              type="submit"
              form="signin"
              isLoading={loading}
              w={"100%"}
            >
              Sign in
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
